export const blockIconsCommonactionsVisibilityOffNew = (
	<span className='material-symbols-outlined'>visibility_off</span>
);
